type IntelligoRuntimeConfig = {
  adminBaseUrl?: string;
  aboutUrl?: string;
  trialHostname?: string;
  managedDomainSuffix?: string;
  managedDomainTargetHostname?: string;
  turnstileSiteKey?: string;
};

declare global {
  interface Window {
    __INTELLIGO_RUNTIME_CONFIG__?: IntelligoRuntimeConfig;
  }
}

const stripTrailingSlashes = (value: string) => value.replace(/\/+$/, "");

const runtimeConfig = window.__INTELLIGO_RUNTIME_CONFIG__ ?? {};

export const ADMIN_CONSOLE_BASE_URL = stripTrailingSlashes(runtimeConfig.adminBaseUrl ?? `${window.location.origin}/a`);
export const ABOUT_URL = runtimeConfig.aboutUrl?.trim() || "https://intelligo.fyi/";
export const TRIAL_HOSTNAME = runtimeConfig.trialHostname?.trim() || "";
export const MANAGED_DOMAIN_SUFFIX = runtimeConfig.managedDomainSuffix?.trim() || "";
export const MANAGED_DOMAIN_TARGET_HOSTNAME = runtimeConfig.managedDomainTargetHostname?.trim() || "";
export const TURNSTILE_SITE_KEY = runtimeConfig.turnstileSiteKey?.trim() || "";
export const VIEW_BASE_URL = `${window.location.origin}/v`;

export const joinBaseUrlWithPath = (baseUrl: string, path: string) => {
  const normalizedBaseUrl = stripTrailingSlashes(baseUrl);
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${normalizedBaseUrl}${normalizedPath}`;
};
